import { useEffect,useState } from "react";
import {
    Box,
    VStack,
    Text,
    Input,
    Button,
    Flex,
    Image,
    InputGroup,
} from "@chakra-ui/react";
import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    loginAction,
} from "../../../../state/actions/authActions";
import { fetchMyDriverPartnerAction } from "../../../../state/actions/driverPartnerActions"

import ActivityToast from
    "../../../../components/ActivityToast";
import { toaster } from "../../../../components/toaster";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";

import Logo from "../../../../assets/logo.png";
import routes from "../../../../routes";

const LoginForm = () => {
    const navigate = useNavigate();
    const dispatch =
    useDispatch();

const {
    loading,
    error,
} = useSelector(
    (state) =>
        state.auth
);



    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const isFormValid =
        username.trim() !== "" &&
        password.trim() !== "";

    useEffect(() => {
    if (error) {
        toaster.create({
            render: () => (
                <ActivityToast
                    type="error"
                    title="Login Failed"
                    description={error}
                    timestamp="Just now"
                />
            ),
        });
    }
}, [error]);

const handleLogin = async () => {
    const response = await dispatch(
        loginAction(
            username,
            password
        )
    );

    if (response?.success) {
        toaster.create({
            render: () => (
                <ActivityToast
                    type="success"
                    title="Login Successful"
                    description="Welcome back to Mogoma Partner Portal."
                    timestamp="Just now"
                />
            ),
        });
         await dispatch(
        fetchMyDriverPartnerAction()
    );
        setTimeout(() => {
            navigate(
                routes.dashboard
            );
        }, 1000);
    }
};

    return (
        <Box
            p={{
                base: 6,
                md: 10,
                lg: 20,
            }}
        >
            <Box
                textAlign="center"
                mb={10}
            >
                <Image
                    src={Logo}
                    h="52px"
                    mx="auto"
                    mb={12}
                />

                <Text
                    fontSize={{
                        base: "36px",
                        md: "48px",
                    }}
                    fontWeight="700"
                    color="#071D54"
                    mb={3}
                    lineHeight="1.1"
                >
                    Welcome Back
                </Text>

                <Text
                    color="gray.600"
                    fontSize="md"
                    maxW="420px"
                    mx="auto"
                >
                    Sign in to manage your Partner business.
                </Text>
            </Box>

            <VStack gap={5}>
                <Input
                    size="lg"
                    placeholder="Email address"
                   value={username}
    onChange={(e) =>
        setUsername(
            e.target.value
        )
    }
                />

                <InputGroup
                    endElement={
                        showPassword ? (
                            <EyeOff
                                size={18}
                                cursor="pointer"
                                onClick={() =>
                                    setShowPassword(false)
                                }
                            />
                        ) : (
                            <Eye
                                size={18}
                                cursor="pointer"
                                onClick={() =>
                                    setShowPassword(true)
                                }
                            />
                        )
                    }
                >
                    <Input
                        size="lg"
                        placeholder="Password"
                        type={
                            showPassword
                                ? "text"
                                : "password"
                        }
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                        onKeyDown={(e) => {
                            if (
                                e.key === "Enter" &&
                                isFormValid
                            ) {
                                handleLogin();
                            }
                        }}
                    />
                </InputGroup>

                <Flex
                    justify="flex-end"
                    w="100%"
                >
                    <Text
                        color="#2453FF"
                        fontWeight="500"
                        cursor="pointer"
                        _hover={{
                            textDecoration: "underline",
                        }}
                        onClick={() =>
                            navigate(
                                routes.forgotPassword
                            )
                        }
                    >
                        Forgot Password?
                    </Text>
                </Flex>

                <Button
                    w="100%"
                    size="lg"
                    bg="#2453FF"
                    color="white"
                    _hover={{
                        bg: "#1E46D8",
                    }}
                    loading={loading}
                    loadingText="Signing In..."
                    disabled={!isFormValid}
                    opacity={
                        !isFormValid ? 0.6 : 1
                    }
                    cursor={
                        !isFormValid
                            ? "not-allowed"
                            : "pointer"
                    }
                    onClick={handleLogin}
                >
                    Sign In
                </Button>
            </VStack>

            <Text
                mt={12}
                textAlign="center"
                color="gray.500"
                fontSize="sm"
            >
                Don't have a Partner account?{" "}
                <Text
                    as="span"
                    color="#2453FF"
                    fontWeight="600"
                    cursor="pointer"
                    _hover={{
                        textDecoration: "underline",
                    }}
                    onClick={() =>
                        navigate(routes.register)
                    }
                >
                    Apply to Become a Partner
                </Text>
            </Text>
        </Box>
    );
};

export default LoginForm;